export const RQ_UPDATE_FINAL_PRODUCT_API = {
  url: 'api/final-product/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_REGISTER_FINAL_PRODUCT_API = {
  url: 'api/final-product/register',
  method: 'POST',
  auth: true,
};

export const RQ_FILTER_FINAL_PRODUCT_API = {
  url: 'api/final-product/filter',
  method: 'POST',
  auth: true,
};

export const RQ_LOOKUP_FINAL_PRODUCT_BY_ID_API = {
  url: 'api/final-product/lookup/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_LOOKUP_ALL_FINAL_PRODUCTS_API = {
  url: 'api/final-product/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_DELETE_FINAL_PRODUCT_API = {
  url: 'api/final-product/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};

export const RQ_GET_DELETED_FINAL_PRODUCTS_API = {
  url: 'api/final-product/deleted',
  method: 'GET',
  auth: true,
};

export const RQ_RESTORE_FINAL_PRODUCT_API = {
  url: 'api/final-product/restore/<%= id %>',
  method: 'PUT',
  auth: true,
};
